import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  addSectionButton: {
    margin: theme.spacing(3, 2, 0, 2),
    width: `calc(100% - ${theme.spacing(4)})`,
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    // 8 -> header, 6 -> routing tabs, 4 -> padding
    height: `calc(100vh - ${theme.spacing(8 + 6 + 4)})`,
    [theme.breakpoints.down('md')]: {
      // 36px -> footer button
      height: `calc(100vh - ${theme.spacing(8 + 6 + 4)} - 36px)`,
    },
  },
  toolbar: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    margin: theme.spacing(-2, -2, 1),
    padding: theme.spacing(2, 1, 0, 4),

    '& p': {
      color: theme.palette.grey['500'],
      display: 'inline-block',
      marginRight: theme.spacing(1),
      position: 'relative',
      top: '1px',
    },
  },
  sectionContainer: {
    backgroundColor: theme.palette.grey[100],
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflowY: 'auto',
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(1),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    '& > div': {
      width: '100%',
      marginTop: theme.spacing(1.5),
    },
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(6),
    right: theme.spacing(1),
    zIndex: 2,
  },
}));
